export const handleFormatTextToBrokeLine = (text: string) => {
  return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
};